export default __webpack_public_path__ + "static/media/handbookEmptyCart.9c0969ce.png";